'use strict';

var _ = require('../dependency')._,
    config = require('../config'),
    $u = require('../utilities'),
    chartTypes = require('./chartTypes');

var GRAPHS = config.graphs,
    $d = config.druid;

var chartId = 'GUEST_CORPORATE_DATA_TREND',
    dataSeries = {
        TIMESTAMP: 'timestamp',
        GUESTDATA: 'guestData',
        CORPORATEDATA: 'nonGuestData'
    },
    fieldNames = {
        GUESTDATA: 'amcApTrafficOverGuestSsidInKbs',
        CORPORATEDATA: 'amcApTrafficOverNonGuestSsidInKbs'
    },
    /**
     * [dataConfig The query params to pass to the API http endpoint POST. Currently this are specific to druid querying.
     * can be modified for other data provider systems.]
     * @type {Object}
     */
    dataConfig = [{
        queryType: 'timeseries',
        /*!ToDo above use this from druid settings object (settings maybe in matrix charts)*/
        dataSource: 'babbage',
        /*above Can be set in library matrix charts*/
        aggregations: [{
            'type': 'longSum',
            'name': dataSeries.GUESTDATA,
            'fieldName': fieldNames.GUESTDATA
        }, {
            'type': 'longSum',
            'name': dataSeries.CORPORATEDATA,
            'fieldName': fieldNames.CORPORATEDATA
        }]
    }];

module.exports = chartTypes.trendCharts.createConfig({
    chartId: chartId,
    dataSeries: dataSeries,
    fieldNames: fieldNames,
    dataConfig: dataConfig,
    chartTemplate: chartTemplate,
    averageTask: false
});

function chartTemplate(data, width) {
    width = parseInt(width.match(/\d+/g)[0], 10);

    var duration = data.__duration,
        granularity = data.__granularity,
        xAxisLabelOffset = $u.charts.getXaxisOffset(duration),
        x = xAxisLabelOffset.x,
        y = xAxisLabelOffset.y,
        legendAdjustments = $u.charts.getLegendAdjustments(duration, false, false);

    var yAxisBaseUnit = 'KB',
        yAxisRoundOff = false,
        xAxisFormatter = $u.charts.generateXaxisDaysData,
        yAxisFormatter = $u.charts.chartYaxisFormatter,
	yAxisTrimDecimalPlaces = 2;

    var chartTemplateObj = {
        dataTableConfig: {
            duration: duration,
            granularity: granularity,
            xAxisFormatter: xAxisFormatter,
            yAxisFormatter: yAxisFormatter,
            yAxisBaseUnit: yAxisBaseUnit,
            yAxisRoundOff: yAxisRoundOff,
            yAxisTrimDecimalPlaces: yAxisTrimDecimalPlaces,
            xAxisDataHeader: 'Dates'
        },
        chart: {
            zoomType: 'x,y',
            marginTop: GRAPHS.GLOBAL.CHART_MARGINS.TOP,
            marginBottom: GRAPHS.GLOBAL.CHART_MARGINS.BOTTOM,
            events: {
                load: function() {
                    var dataUnit,
                        chartContext = this,
                        dataArray;

                    _.forEach(chartContext.yAxis, function(yAxisObject) {
                        dataArray = [];
                        dataUnit = ' ';
                        _.forEach(yAxisObject.series, function(seriesItem) {
                            dataArray.push(seriesItem.dataMax);
                        });
                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), 'KB').unit;
                        yAxisObject.setTitle({
                            text: data.i18n.YAXIS_TEXT + ' ' + dataUnit
                        });
                    });
                }
            }
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        legend: {
            y: legendAdjustments.y,
            itemDistance: legendAdjustments.itemDistance
        },
        tooltip: {
            formatter: function() {
                var that = this,
                    tooltipUnitObj = yAxisFormatter(that.y, that.series.dataMax, yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces);

                return $u.charts.sformat('{0}<br>{1} {2}: <b>{3}{4}</b>',
                    xAxisFormatter(duration, granularity, that.x),
                    that.series.name,
                    'Data Usage',
                    tooltipUnitObj.value,
                    tooltipUnitObj.unit
                );
            },
            valueDecimals: 0
        },
        xAxis: {
            categories: data[dataSeries.TIMESTAMP],
            /*!ToDo this may be a setting for druid default time series name*/
            tickmarkPlacement: 'on',
            labels: {
                step: function() {
                    if (data.timestamp) {
                        return data.timestamp.length >=
                            GRAPHS.GLOBAL.MAX_XAXIS_LABELS ? 2 : 1;
                    }
                }(),
                rotation: -45,
                align: 'center',
                x: x,
                y: y,
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                formatter: function() {
                    return xAxisFormatter(duration, granularity, this.value);
                },
                useHTML: true,
                autoTransform: true
            }
        },
        yAxis: [{
            allowDecimals: false,
            title: {
                text: '',
                style: {
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_TITLE,
                    color: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY
                }
            },
            labels: {
                format: '{value}',
                formatter: function() {
                    var that = this,
                        yAxisValue = that.value,
                        yMaxValue = that.axis.dataMax;
                    return yAxisFormatter(yAxisValue, yMaxValue,
                        yAxisBaseUnit, yAxisRoundOff, yAxisTrimDecimalPlaces).value;
                },
                style: {
                    fontFamily: GRAPHS.GLOBAL.FONT_FAMILY,
                    fontSize: GRAPHS.GLOBAL.CHART_FONT_SIZE.AXIS_LABEL
                },
                x: -20
            },
            min: 0,
            maxPadding: 0.1,
            lineColor: GRAPHS.GLOBAL.COLORS.MOJO_DARK_GREY,
            lineWidth: 1
        }],
        plotOptions: {
            line: {
                marker: {
                    enabled: true,
                    radius: width / 400 + 1
                }
            },
            series: {
                events: {
                    legendItemClick: function() {
                        var dataUnit,
                            legendContext = this,
                            legendIndex = legendContext.index,
                            dataArray = [];

                        _.forEach(legendContext.chart.legend.allItems, function(legendItem) {
                            if (legendItem.index === legendIndex) {
                                if (!legendItem.visible) {
                                    dataArray.push(legendItem.dataMax);
                                }
                            } else {
                                if (legendItem.visible) {
                                    dataArray.push(legendItem.dataMax);
                                }
                            }
                        });

                        dataUnit = $u.charts.getUnitsFromMax(_.max(dataArray), 'KB').unit;

                        legendContext.yAxis.setTitle({
                            text: data.i18n.YAXIS_TEXT + ' ' + dataUnit
                        });
                    }
                }
            }
        },
        series: [{
            type: 'line',
            name: 'Guest',
            data: data[dataSeries.GUESTDATA],
            color: GRAPHS.GLOBAL.COLORS.MOJO_RED,
        }, {
            type: 'line',
            name: 'Corporate',
            data: data[dataSeries.CORPORATEDATA],
            color: GRAPHS.GLOBAL.COLORS.MOJO_BLUE,
        }]
    };
    chartTemplateObj = _.assign({}, config.defaultSettings, chartTemplateObj);
    return chartTemplateObj;
}
